export default {
  root: { backgroundColor: '#FFFFFF' },
  dialogContent: { overflow: 'visible' }
};
